export default "__VITE_ASSET__a8b39765__"